import type { PipelineCatalogEntry } from 'app/components/action-center/usePipelinesCatalog'
import type { List } from 'app/generated/graphql'
import type { ListMembership } from 'app/types/list-memberships'
import { defaultStageIdOf, isPracticeList } from 'lib/practiceLists'

export function listCatalogEntry(
  list: Pick<List, `id` | `name` | `stages`>,
  bookedStage?: string,
): PipelineCatalogEntry {
  const stages = (list.stages ?? []).map((stage, order) => ({ name: stage.name, color: stage.color, order }))
  const lockedStage = stages.some((stage) => stage.name === bookedStage) ? bookedStage : undefined
  return { id: list.id, name: list.name, stages, lockedStage }
}

export function practiceListCatalog(lists: readonly List[]): PipelineCatalogEntry[] {
  return lists
    .filter((list) => isPracticeList(list) && (list.stages?.length ?? 0) > 0)
    .map((list) => listCatalogEntry(list))
}

export function stageIdForName(list: Pick<List, `stages`>, name: string): string | undefined {
  return list.stages?.find((stage) => stage.name === name)?.id
}

export function shownStageName(
  list: Pick<List, `stages` | `defaultStageId`>,
  stageId: string | undefined,
): string | undefined {
  const stages = list.stages ?? []
  const known = stages.find((stage) => stage.id === stageId)
  return (known ?? stages.find((stage) => stage.id === defaultStageIdOf(list)))?.name
}

export function membershipEntries(
  memberships: readonly ListMembership[],
  lists: readonly List[],
): { id: string; stage: string | undefined }[] {
  const stageByList = new Map(memberships.map((membership) => [membership.listId, membership.stageId]))
  return lists
    .filter((list) => stageByList.has(list.id) && isPracticeList(list) && (list.stages?.length ?? 0) > 0)
    .map((list) => ({ id: list.id, stage: shownStageName(list, stageByList.get(list.id)) }))
}
